import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class ProxyInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (environment.backendUrl) {
      if (/^\/bff-b2bweb(?:\/|\?|$)/.test(request.url)) {
        request = request.clone({
          url: `${environment.backendUrl.replace(/\/$/, '')}${request.url}`,
        });
      }
    }

    return next.handle(request);
  }
}
